<template>
  <div class="error-global" v-bind:class="{'error-global__open': open}">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'error-global',
  props: {},
  data() {
    return {
      open: false,
      message: '',
    };
  },
  methods: {
    show(message) {
      if (message) {
        this.open = true;
      }
      this.message = message;
    },
    hide() {
      this.open = false;
      this.message = '';
    },
  },
};
</script>

<style scoped>
.error-global {
  position: fixed;
  top: 0;
  left: 0;
  color: #fff;
  background: #fa6161;
  padding: 10px 20px;
  width: 100%;
  z-index: 5000;
  display: none;
}
.error-global__open {
  display: block;
}
</style>
